export const LS_ORIGINAL_POINTS_KEY = 'GIDE-original-points';
export const LS_MAP_CENTER_AND_ZOOM_KEY = 'GIDE-map-center-and-zoom';
export const LS_POLYGON_STORES_KEY = 'GIDE-polygon-stores';
export const LS_ROAD_NET_STORES_KEY = 'GIDE-road-net-stores';
export const LS_FORBIDDEN_STORES_KEY = 'GIDE-forbidden-stores';

export const MSID_ORIGINAL_POINTS = 'GIDE-original-points-source';
export const MLID_ORIGINAL_POINTS = 'GIDE-original-points-layer';
export const MSID_ORIGINAL_POINTS_FOCUSED = 'GIDE-original-points-focused-source';
export const MLID_ORIGINAL_POINTS_FOCUSED = 'GIDE-original-points-focused-layer';
export const MSID_POLYGON_GENERATOR_OUTLINE = 'GIDE-polygon-generator-outline-source';
export const MLID_POLYGON_GENERATOR_OUTLINE = 'GIDE-polygon-generator-outline-layer';
export const MSID_POLYGON_GENERATOR_NAVILINE = 'GIDE-polygon-generator-naviline-source';
export const MLID_POLYGON_GENERATOR_NAVILINE = 'GIDE-polygon-generator-naviline-layer';
export const MSID_POLYGONS = 'GIDE-polygons-source';
export const MLID_POLYGONS = 'GIDE-polygons-layer';
export const MSID_POLYGON_EDITOR = 'GIDE-polygon-editor-source';
export const MLID_POLYGON_EDITOR = 'GIDE-polygon-editor-layer';
export const MSID_REMOTE_POLYGONS = 'GIDE-remote-polygons-source';
export const MSID_REMOTE_POLYGONS_NO_REGION = 'GIDE-remote-polygons-source-no-region';
export const MLID_REMOTE_POLYGONS = 'GIDE-remote-polygons-layer';
export const MLID_REMOTE_POLYGONS_NO_REGION = 'GIDE-remote-polygons-layer-no-region';
export const MSID_REMOTE_POLYGONS_BUFFER = 'GIDE-remote-polygons-buffer-source';
export const MLID_REMOTE_POLYGONS_BUFFER = 'GIDE-remote-polygons-buffer-layer';
export const MSID_REMOTE_POLYGONS_NO_REGION_BUFFER = 'GIDE-remote-polygons-no-region-buffer-source';
export const MLID_REMOTE_POLYGONS_NO_REGION_BUFFER = 'GIDE-remote-polygons-no-region-buffer-layer';
export const MSID_REGIONS = 'GIDE-regions-source';
export const MLID_REGIONS = 'GIDE-regions-layer';
export const MSID_REGION_EDITOR = 'GIDE-region-editor-source';
export const MLID_REGION_EDITOR = 'GIDE-region-editor-layer';
export const MSID_REGION_EDITOR_POLYGON = 'GIDE-region-editor-polygon-source';
export const MLID_REGION_EDITOR_POLYGON = 'GIDE-region-editor-polygon-layer';
export const MSID_REGION_BUFFER = 'GIDE-region-buffer-source';
export const MLID_REGION_BUFFER = 'GIDE-region-buffer-layer';
export const MSID_PARK_POINT_USER = 'GIDE-park-point-user-source';
export const MLID_PARK_POINT_USER = 'GIDE-park-point-user-layer';
export const MSID_PARK_POINT_STOCK = 'GIDE-park-point-stock-source';
export const MLID_PARK_POINT_STOCK = 'GIDE-park-point-stock-layer';
export const MSID_POINT_TO_MEASURE = 'GIDE-point-to-measure-source';
export const MLID_POINT_TO_MEASURE = 'GIDE-point-to-measure-layer';
export const MSID_PROHIBITED_AREAS = 'GIDE-prohibited-areas-source';
export const MLID_PROHIBITED_AREAS = 'GIDE-prohibited-areas-layer';
export const MSID_FORBIDDEN_AREAS = 'GIDE-forbidden-areas-source';
export const MLID_FORBIDDEN_AREAS = 'GIDE-forbidden-areas-layer';
export const MSID_FORBIDDEN_AREAS_EDITOR = 'GIDE-forbidden-areas-edit-source';
export const MLID_FORBIDDEN_AREAS_EDITOR = 'GIDE-forbidden-areas-edit-layer';
export const MSID_REMOTE_FORBIDDENS = 'GIDE-remote-forbidden-source';
export const MLID_REMOTE_FORBIDDENS = 'GIDE-remote-forbidden-layer';
export const MSID_POINT_TO_PHOTO = 'GIDE-point-to-photo-source';
export const MLID_POINT_TO_PHOTO = 'GIDE-point-to-photo-layer';
export const MSID_INSPECTION_AREAS = 'GIDE-inspection-areas-source';
export const MLID_INSPECTION_AREAS = 'GIDE-inspection-areas-layer';
export const MSID_ROAD_NET = 'GIDE-road-net-source';
export const MLID_ROAD_NET = 'GIDE-road-net-layer';
export const MSID_ROAD_NET_EDITOR = 'GIDE-road-net-editor-source';
export const MLID_ROAD_NET_EDITOR = 'GIDE-road-net-editor-layer';
export const MSID_ROAD_NET_EDITOR_LOCAL = 'GIDE-road-net-editor-local-source';
export const MLID_ROAD_NET_EDITOR_LOCAL = 'GIDE-road-net-editor-local-layer';
export const MSID_ROAD_NET_REMOTE_AND_LOCAL_POINT = 'GIDE-road-net-remote-and-local-source';
export const MLID_ROAD_NET_REMOTE_AND_LOCAL_POINT = 'GIDE-road-net-remote-and-local-layer';
export const MSID_ROAD_NET_GENERATOR_OUTLINE = 'GIDE-road-net-generator-outline-source';
export const MLID_ROAD_NET_GENERATOR_OUTLINE = 'GIDE-road-net-generator-outline-layer';
export const MSID_ROAD_NET_GENERATOR_NAVILINE = 'GIDE-road-net-generator-naviline-source';
export const MLID_ROAD_NET_GENERATOR_NAVILINE = 'GIDE-road-net-generator-naviline-layer';
export const MSID_AFTER_STOCK_PLACE = 'GIDE-point-after-stock-place-source';
export const MLID_AFTER_STOCK_PLACE = 'GIDE-point-after-stock-place-layer';
export const MSID_BEFORE_STOCK_PLACE = 'GIDE-point-before-stock-place-source';
export const MLID_BEFORE_STOCK_PLACE = 'GIDE-point-before-stock-place-layer';
export const MSID_ROAD = 'GIDE-road-source';
export const MLID_ROAD = 'GIDE-road-layer';
export const MSID_ROAD_FURNITURE = 'GIDE-road-furniture-source';
export const MLID_ROAD_FURNITURE = 'GIDE-road-furniture-layer';
export const MSID_ROAD_LANE_DIVIDER = 'GIDE-road-lane-divider-source';
export const MLID_ROAD_LANE_DIVIDER = 'GIDE-road-lane-divider-layer';
export const MSID_BACKLOG_POINT = 'GIDE-backlog-point-source';
export const MLID_BACKLOG_POINT = 'GIDE-backlog-point-layer';
export const MLID_BACKLOG_CIRCLE = 'GIDE-backlog-circle-layer';
export const MSID_BACKLOG_CIRCLE = 'GIDE-backlog-circle-source';
export const MSID_ADJUSTMENT_POINT = 'GIDE-adjustment-point-source';
export const MSID_ADJUSTMENT_POINT_FINISHED = 'GIDE-adjustment-point-finished-source';
export const MLID_ADJUSTMENT_POINT = 'GIDE-adjustment-point-layer';
export const MLID_ADJUSTMENT_POINT_FINISHED = 'GIDE-adjustment-point-finished-layer';
export const MSID_HEATMAP = 'GIDE-heatMap-source';
export const MSID_DISPATCH_WORK_ORDER = 'GIDE-dispatch-work-order-source';
export const MLID_HEATMAP_POINT = 'GIDE-heatMap-point-layer';
export const MLID_HEATMAP_POLYGON = 'GIDE-heatMap-layer';
export const MLID_DISPATCH_WORK_ORDER = 'GIDE-dispatch-work-order-layer';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/utils/constants.ts